module.exports = __webpack_public_path__ + "static/media/whappo-logo.6c7aa197.png";